import { ICreateControlePatrimonioControleUseCase } from "../../../presentation/useCases/create/create_controle_patrimonio_controle_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreateControlePatrimonioControleUseCase
 */

export class CreateControlePatrimonioControleUseCase implements ICreateControlePatrimonioControleUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createControlePatrimonioControle(
    idCentroCusto: number,
  ): Promise<number> {
    return await this.repository.createControlePatrimonioControle(idCentroCusto);
  }
}
